<template>
    <div>
        <h1 class="Gallery">PROJECTS</h1>
        <div class="projects">
            <div id="prj1" class="project">
            </div>
            <div id="prj2" class="project">
            </div>
            <div id="prj4" class="project">
            </div>
            <div id="prj5" class="project">
            </div>
            <div id="prj6" class="project">
            </div>
            <div id="prj7" class="project">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
    .Gallery{
        font-family: 'Old Standard TT', ;
        font-size: 50px;
        letter-spacing: 5px;
        text-align: center;
        padding-top: 80px;
        color: rgb(0, 0, 0);
    }
    .projects{
        display: flex;
        width: 95%;
        margin-left: 2.5%;
        flex-direction: row;
        flex-wrap: wrap;
        margin: 100px 5% 100px 5%;
    }
    .project{
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        width: 31%;
        margin: 0.6%;
        box-shadow: 0px 0px 8px 1px rgba(0, 0, 0, 0.801);
        height: 400px;
        .description{
            display: none;
            width: 90%;
            color: white;
            position: absolute;
            bottom: 10px;
            left: 20px;
        }
    }
    .project:hover{
        .description{
            display: block;
        }
    }
    #prj1{
        background-image: url("../assets/el1.jpg");
    }
    #prj2{
        background-image: url("../assets/el2.jpg")
    }
    #prj4{
        background-image: url("../assets/el4.jpg")
    }
    #prj5{
        background-image: url("../assets/el5.jpg");
    }
    #prj6{
        background-image: url("../assets/el6.jpg")
    }
    #prj7{
        background-image: url("../assets/el7.jpg")
    }
    #prj8{
        background-image: url("../assets/el8.jpg")
    }
    @media only screen and (max-width: 900px) {
        .projects{
            flex-direction: column;

        }
    
    .project{
        width: 90%;
        margin: 5%;
        box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.301);
        height: 300px;
        .description{
            display: block;
        }
    }
    #prj1{
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.781)),url("../assets/el1.jpg");
    background-size: cover;
    }
    #prj2{
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.781)),url("../assets/el2.jpg");
    background-size: cover;
    }
    #prj3{
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.781)),url("../assets/el3.jpg");
    background-size: cover;
    }
    #prj4{
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.781)),url("../assets/el4.jpg");
    background-size: cover;
    }
    }
</style>